import { LoadingButton } from "@mui/lab";
import { Box, buttonClasses, Divider, IconButton, svgIconClasses } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";

import { APP_HEADER_HEIGHT, APP_MOBILE_HEADER_HEIGHT, COLORS } from "../consts";
import palette from "src/theme/palette";
import { SNIPPET_Z_INDEX } from "src/components/widgets/overview/Snippet";

const PREVIEW_BANNER_HEIGHT = 50;

export const Header = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== "showHeaderSkeleton" && prop !== "editBackground" && prop !== "isPreviewMode"
})(({ theme, showHeaderSkeleton, editBackground, isPreviewMode }) => ({
  display: showHeaderSkeleton ? "none" : "flex",
  flexDirection: "column",
  position: "fixed",
  boxShadow: "none",
  backgroundColor: editBackground ?? "#FFFFFF",
  borderBottom: "1px solid rgba(45, 44, 68, 0.12)",
  zIndex: isPreviewMode ? SNIPPET_Z_INDEX : theme.zIndex.drawer + 1,
  [theme.breakpoints.down("sm")]: {
    height: isPreviewMode ? APP_MOBILE_HEADER_HEIGHT + PREVIEW_BANNER_HEIGHT : APP_MOBILE_HEADER_HEIGHT,
    padding: "6px 16px",
    justifyContent: "center"
  },
  [theme.breakpoints.up("sm")]: {
    height: isPreviewMode ? APP_HEADER_HEIGHT + PREVIEW_BANNER_HEIGHT : APP_HEADER_HEIGHT,
    padding: "14px 24px"
  },
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
}));

export const StyledDivider = styled(Divider)(() => ({
  marginLeft: "12px",
  height: "100%"
}));

export const StyledButton = styled(LoadingButton, {
  shouldForwardProp: (prop) => prop !== "extraPadding"
})`
  height: 36px;
  line-height: 20px;
  margin-right: 4px;
  padding: 8px ${({ extraPadding }) => extraPadding ? "20px" : "12px"};

  box-shadow: unset;
  ${({ variant }) => variant === "outlined" && "background-color: #ffffff;"}
  ${({ variant }) => variant === "outlined" && `border: 1px solid ${COLORS.BTN_BORDER_COLOR};`}
  ${({ variant, disabled }) => variant === "contained" && !disabled && `
  outline: 1px solid ${COLORS.BTN_BORDER_COLOR};
  outline-offset: -1px;
  `}

  &:disabled {
    ${({ variant, disabled }) => variant === "contained" && !disabled && `outline: 1px solid ${COLORS.DISABLED_BTN_BORDER_COLOR};`}
    background-color: #ffffff;
  }

  &:hover {
    box-shadow: unset;
    background-color: ${({ variant, theme }) => variant === "outlined" ? COLORS.OUTLINED_HOVER_BTN_BG : theme.palette.primary[500]};
    ${({ variant }) => variant === "outlined" && `outline: 1px solid ${COLORS.BTN_BORDER_COLOR}; outline-offset: -1px;`}
  }

  .${buttonClasses.startIcon} {
    margin-left: 0;
  }
`;

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "isActive" && prop !== "rounded"
})`
  padding: 6px;
 ${({ variant, rounded }) =>
    variant === "outlined" && `
      background-color: #ffffff;
      border-radius: ${rounded ? "50%" : "8px"};
      border: 1px solid ${COLORS.DISABLED_BTN_BORDER_COLOR};
    `}
  ${({ variant, disabled }) => variant === "contained" && !disabled && `
  outline: 1px solid ${COLORS.BTN_BORDER_COLOR};
  outline-offset: -1px;
  `}
  ${({ variant, isActive }) =>
    variant === "text" && isActive && `
      background-color: ${COLORS.ICON_BTN_HOVER_BG};
  `}
&:hover {
   background-color: ${({ variant }) => variant === "outlined" ? COLORS.OUTLINED_HOVER_BTN_BG : COLORS.ICON_BTN_HOVER_BG};
   ${({ variant, theme }) =>
        variant === "outlined" && `
    outline: 1px solid ${COLORS.BTN_BORDER_COLOR};
    outline-offset: -1px;
   .${svgIconClasses.root} {
      fill: ${theme.palette.primary[500]};
    }`
    }
 }
`;

export const PreviewBannerContainer = styled(Box)({
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
  height: "50px",
  backgroundColor: palette.system[0],
  borderTop: `1px solid ${palette.system[200]}`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
